export default "__VITE_PUBLIC_ASSET__1d123816__"